import Icon from 'vue-awesome/components/Icon'

export default Icon.register({
  'html5-c': {
    width: 1024,
    height: 1024,
    raw: '<path d="M882 210L686.2 14c-9-9-21.2-14-34-14H640v256h256v-12.2c0-12.6-5-24.8-14-33.8z m-306 62V0H176C149.4 0 128 21.4 128 48v928c0 26.6 21.4 48 48 48h672c26.6 0 48-21.4 48-48V320H624c-26.4 0-48-21.6-48-48z m-192 598.4c0 12.8-12.8 25.6-25.6 25.6H281.6c-12.8 0-25.6-12.8-25.6-25.6v-140.8c0-12.8 12.8-25.6 25.6-25.6h76.8c12.8 0 25.6 12.8 25.6 25.6v140.8z m192 0c0 12.8-12.8 25.6-25.6 25.6h-76.8c-12.8 0-25.6-12.8-25.6-25.6V473.6c0-12.8 12.8-25.6 25.6-25.6h76.8c12.8 0 25.6 12.8 25.6 25.6v396.8z m64-268.8c0-12.8 12.8-25.6 25.6-25.6h76.8c12.8 0 25.6 12.8 25.6 25.6v268.8c0 12.8-12.8 25.6-25.6 25.6h-76.8c-12.8 0-25.6-12.8-25.6-25.6V601.6z" p-id="2710" fill="#ffffff" />'
  }
}
)
